(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/event-number.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/event-number.js');
"use strict";

const {
  useWagerCurrentCorrectValues
} = svs.components.tipsen.hooksWager;
const {
  constants: {
    MatchCorrectStatus
  },
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  MatchNumberIcon,
  constants: {
    matchNumberTextColor,
    matchCorrectStatusColor
  }
} = svs.components.tipsen.matchNumberIcon;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  ReactBadge: Badge
} = svs.ui;
const {
  useLocation
} = ReactRouterDOM;
const MatchNumber = _ref => {
  let {
    isCompressed = false,
    eventNumber,
    branding
  } = _ref;
  const location = useLocation();
  const isResult = location.pathname.includes("/".concat(TipsenModuleGameUrl.RESULT));
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  if (!isResult && (isSmall || isCompressed)) {
    return React.createElement("div", {
      className: "pg_coupon_static__event_number f-medium"
    }, "".concat(eventNumber, "."));
  }
  return React.createElement("div", {
    className: "pg_coupon_static__event_number"
  }, React.createElement(Badge, {
    branding: branding
  }, eventNumber));
};
const EventNumber = _ref2 => {
  let {
    drawResult,
    eventNumber,
    eventTypeId = 1,
    userRow = [],
    bestBetRowResult,
    isCompressed = false,
    branding
  } = _ref2;
  const rowCorrectStatus = useWagerCurrentCorrectValues({
    drawResult,
    eventNumber,
    eventTypeId,
    userRow,
    bestBetRowResult
  });
  const gameIcon = 'game-soccer'; 
  let iconColor;
  switch (rowCorrectStatus) {
    case MatchCorrectStatus.NOT_CORRECT:
      iconColor = matchCorrectStatusColor.NOT_CORRECT;
      break;
    case MatchCorrectStatus.CORRECT:
      iconColor = matchCorrectStatusColor.CORRECT;
      break;
    case MatchCorrectStatus.POSSIBLE_WIN:
      iconColor = matchCorrectStatusColor.POSSIBLE_WIN;
      break;
    default:
      iconColor = matchCorrectStatusColor.NONE;
  }
  if (eventTypeId !== EventTypeId.GOAL_COUNT || isCompressed) {
    return React.createElement(MatchNumber, {
      branding: branding,
      eventNumber: eventNumber,
      isCompressed: isCompressed
    });
  }
  return React.createElement("div", {
    className: "pg_coupon_static__event_number"
  }, React.createElement(MatchNumberIcon, {
    color: iconColor,
    icon: gameIcon,
    text: eventNumber.toString(),
    textColor: matchNumberTextColor.WHITE
  }));
};
setGlobal('svs.components.tipsen.couponStatic.EventNumber', EventNumber);

 })(window);